import { render, staticRenderFns } from "./AgeStep.vue?vue&type=template&id=31a0ee06&scoped=true&"
import script from "./AgeStep.vue?vue&type=script&lang=js&"
export * from "./AgeStep.vue?vue&type=script&lang=js&"
import style0 from "./AgeStep.vue?vue&type=style&index=0&id=31a0ee06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a0ee06",
  null
  
)

export default component.exports